import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter } from '../../global/commonStyle';

interface Props {
  textBlack?: boolean;
  isSelectedRepeat?: boolean;
}
const AssignBox = styled.div`
  min-width: 200px;
`;

const AssignHead = styled.form`
  padding: var(--space-4) var(--space-16) var(--space-4) var(--space-12);
  ${mobile_xl(css`
    padding: var(--space-0) var(--space-12) var(--space-0) var(--space-24);
  `)}
`;

const AssignBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
`;

const Calender = styled.div<Props>`
  width: 100%;
  .icon {
    width: 14px;
    height: 14px;
    ${mobile_xl(css`
      width: 16px;
      height: 16px;
    `)}
  }
  .text-center {
    margin: var(--space-0);
    ${Typography.body_md}
    color: var(--text-primary);
    ${(props: Props) =>
      props.textBlack &&
      css`
        color: var(--text-primary);
      `}
  }
  ${mobile_xl(css`
    padding-block: var(--space-8);
  `)}

  .react-calendar {
    max-width: 100%;
    ${Typography.body_xs}
    text-align: center;
    letter-spacing: 0.1px;
    color: var(--text-secondary);
    ${mobile_xl(css`
      padding-inline: var(--space-4);
    `)}
  }
  .react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: repeat(7, 1fr);
    gap: var(--space-2);
  }
  .react-calendar--doubleView {
    width: 700px;
  }
  .react-calendar__month-view {
    flex-grow: unset;
  }
  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    border-radius: var(--border-radius-full);
    background-color: var(--text-secondary);
  }
  .react-calendar--doubleView .react-calendar__viewContainer {
    display: flex;
    margin: -0.5em;
  }
  .react-calendar--doubleView .react-calendar__viewContainer > * {
    width: 50%;
    margin: var(--space-8);
  }
  .react-calendar,
  .react-calendar *,
  .react-calendar *:before,
  .react-calendar *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-decoration: none;
  }
  .react-calendar button {
    margin: var(--space-0);
    border: 0;
    outline: none;
  }
  .react-calendar button:enabled:hover {
    cursor: pointer;
  }
  .react-calendar__navigation {
    display: flex;
    margin-bottom: var(--space-13);
    padding-block: var(--space-4);
    ${mobile_xl(css`
      margin-bottom: var(--space-16);
      gap: var(--space-12);
    `)}
  }
  .react-calendar__navigation button {
    ${Typography.body_lg_semibold}
    font-family: 'Inter';
    background: none;
    height: 20px;
    padding: var(--space-0);
    color: var(--text-primary);
    width: 20px;
    ${FlexCenter}
    &:hover {
      background-color: var(--neutral-secondary);
      border-radius: var(--border-radius-full);
    }
    ${mobile_xl(css`
      padding: var(--space-0);
      width: 26px;
      height: 26px;
      svg {
        width: 16px;
        height: 16px;
      }
    `)}
  }

  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: var(--space-8);
    ${Typography.body_xs}
    ${mobile_xl(css`
      ${Typography.body_sm_medium}
      margin-bottom: var(--space-12);
    `)}
  }
  .react-calendar__month-view__weekdays__weekday {
    ${mobile_xl(css`
      padding: var(--space-0);
    `)}
  }
  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    ${FlexCenter}
    ${Typography.body_xs}
  }

  .react-calendar__year-view .react-calendar__tile,
  .react-calendar__decade-view .react-calendar__tile,
  .react-calendar__century-view .react-calendar__tile {
    padding: var(--space-2);
  }
  .react-calendar__year-view__months__month {
    overflow: auto;
  }
  .react-calendar__tile {
    max-width: 100%;
    padding: var(--space-2);
    background: none;
    text-align: center;
    ${Typography.body_md}
    color: var(--text-primary);
    ${mobile_xl(css`
      padding: var(--space-11) var(--space-12);
    `)}
  }
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background: var(--text-secondary);
    color: var(--text-white);
    border-radius: var(--border-radius-full);
  }
  .react-calendar__tile--now {
    border-radius: var(--border-radius-full);
  }
  .react-calendar__tile--active:enabled:hover {
    background: var(--text-secondary);
    color: var(--background-primary);
  }

  .react-calendar__tile--active:enabled {
    background: var(--text-secondary);
    color: var(--background-primary);
    ${mobile_xl(css`
      max-width: 44px;
      width: 100%;
    `)}
  }

  .react-calendar__tile--active {
    border-radius: var(--border-radius-full);
    background: var(--text-primary);
    color: var(--text-white);
  }

  .react-calendar__year-view__months {
    row-gap: var(--space-3);
  }
`;

const BottomSection = styled.div<Props>`
  padding-inline: var(--space-4);
  ${FlexCenter}
  position: relative;
  ${(props: Props) =>
    props.isSelectedRepeat &&
    css`
      flex-direction: column-reverse;
      padding: var(--space-0);
    `}
`;

const RightSide = styled.div`
  ${FlexCenter}
  gap: var(--space-8);
  cursor: pointer;
  p {
    margin: var(--space-0);
    color: var(--text-primary);
    ${Typography.body_md}
  }
`;

const Div = styled.div<Props>`
  ${FlexCenter}
  position: relative;
  min-width: 198px;
  padding: var(--space-4) var(--space-6);
  ${(props: Props) =>
    props.isSelectedRepeat &&
    css`
      ${FlexBetween}
      gap: var(--space-12)
    `}
`;

const Weekly = styled.div`
  ${AlignCenter}
  gap: var(--space-4);
  cursor: pointer;
  p {
    margin: var(--space-0);
    color: var(--text-secondary);
    ${Typography.body_md}
    text-transform: capitalize;
  }
`;

const Submenu = styled.div`
  display: flex;
  flex-direction: column;
  ${Typography.body_md}
`;

const CalenderMainDiv = styled.div`
  align-items: center;
  padding: var(--space-8);
  ${mobile_xl(css`
    padding: var(--space-0) var(--space-10);
  `)}
`;
export {
  AssignBox,
  AssignHead,
  AssignBlock,
  Calender,
  BottomSection,
  RightSide,
  Div,
  Weekly,
  Submenu,
  CalenderMainDiv
};
